import type { AsyncSequence } from "../types/AsyncSequence"
import type { Sequence } from "../types/Sequence"
import { Channel } from "../classes/Channel"
import { Map } from "../functions/Map"
import { ProcessIterable } from "./ProcessIterable"

export function JoinConcurrent<T>(
  ...arrays: AsyncGenerator<AsyncGenerator<T>>[]
): AsyncGenerator<T>
export function JoinConcurrent<T>(
  ...arrays: AsyncGenerator<AsyncSequence<T>>[]
): AsyncGenerator<T>
export function JoinConcurrent<T>(
  ...arrays: Sequence<AsyncSequence<T>>[]
): AsyncGenerator<T>
export function JoinConcurrent<T>(
  ...arrays: AsyncSequence<AsyncSequence<T>>[]
): AsyncGenerator<T> {
  const { push, stop, stream } = Channel<T>()

  const promises = Map(iterable => {
    const inner: Promise<void>[] = []
    return ProcessIterable(iterable, sequence => {
      inner.push(ProcessIterable(sequence, push))
    }).then(() => Promise.all(inner))
  }, arrays)

  void Promise.all(promises).then(
    () => stop(undefined),
    error => stop(error)
  )

  return stream
}
